import React from 'react';
import { Flex, Row, List } from 'antd';
import { TagOutlined, FormOutlined, UnorderedListOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import SwitchShop from '../../shop/switch-shop';
import CardTmpList from './tmp-list';
import { getCurrentShopId } from '../../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [list, setList] = React.useState([]);

    React.useEffect(() => {
        getList().then(res => {
            setList(res);
        });
    }, []);
    const getList = async () => {
        const shopId = await getCurrentShopId();
        const response = await fetch(`/api/goods-card/list?shopId=${shopId}`);
        const result = await response.json();

        if(result?.success) {
            return result?.data?.rows;
        }else{
            return [];
        }
    };

    return (
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/promotion/goods-card-template/create" text="创建次卡">
                    <FormOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/promotion/goods-card-list" text="次卡售卖明细">
                    <UnorderedListOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <h2>次卡模版列表</h2>
            <CardTmpList cardList={list} />
        </div>
    )
}